import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import { CashSales } from "../../../../components/modules/sales/cash-sales";
import CashSalesMiddleware from "../../../../middleware/modules/sales/cash-sales";
// middlewares
const mapStateToProps = ({ auth, cashSales }) => ({
  isProcessing: cashSales.isProcessing,
  isError: cashSales.isError,
  errorMessage: cashSales.errorMessage,
  data: cashSales.data,
  showModal: cashSales.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      void: (id,search) => CashSalesMiddleware.beforeVoid(id,search),
      reset: () => CashSalesMiddleware.resetList(),
      search: (data) => CashSalesMiddleware.list(data),
      Reconcile: (data) => CashSalesMiddleware.showReconcile(data),
    },
    dispatch
  );
};
class CashSalesContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    data: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    data: {},
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }
  render() {
    return (
      <React.Fragment>
      <Helmet>
        <title>
          {i18n.t("Reconcile Cash Sales")}
        </title>
      </Helmet>
      <CashSales {...this.props} />
    </React.Fragment>
    );
    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashSalesContainer);
